export const features = {
  ops: {
    runtimeInspectorVisible: "ops.runtime-control.inspector",
    apolloClientConnectToDevTools: "ops.apollo-client.connect-to-devtools"
  },
  pdt: {
    pendo: {
      scriptInjectionEnabled: "pdt.pendo-script-injection"
    },
    createSimpleOperationalHierarchy: {
      manageHierarchyButton:
        "pdt.create-simple-operational-hierarchy.manage-hierarchy-button"
    },
    supportForm: {
      showSupportForm: "pdt.display.common-org-entity.support-form"
    },
    entities: {
      developerEntitySelfService: "pdt.developer-entity-self-service",
      syntheticTenantToggle: "pdt.developer-entity-synthetic-tenant-toggle"
    },
    productUpdates: {
      internalExperience: "pdt.product-updates-internal-experience"
    }
  },
  dev: {
    unitTestFlag: "dev.unit-test-flag",
    tenancy: {
      tenancyTab: "dev.tenancy.tenancy-tab"
    },
    springBffPassthrough: {
      searchAndHierarchy: "dev.spring-bff-passthrough-search-and-hierarchy"
    },
    productUpdates: {
      adminComponent: "dev.product-updates.admin-component"
    },
    tabComponents: {
      unmountInactive: "dev.pbc.tab-components.unmount-inactive"
    },
    createSimpleOperationalHierarchy: {
      enableDemo: "dev.create-simple-operational-hierarchy.demo"
    },
    boidEdit: {
      showBoidEditTable: "dev.show-boid-edit-table"
    }
  }
};
